import React from "react"
import { Form } from "sharedTypes"
import SidePanelForm from "components/Builder/components/SidePanelForm"
import { BuilderType } from "sharedTypes/builder"
import AddContentSection from "components/Builder/AddContentSection"
import SidePanelHeader from "components/Builder/components/SidePanelHeader"

type Props = {
  onAttributeChange: (formData: Form) => void
}

const EditPageContentModalSettingsPanel = ({
  onAttributeChange,
}: Props) => (
  <SidePanelForm onChange={onAttributeChange} initialValues={{}}>
    {() => (
      <>
        <SidePanelHeader>Web Page Builder</SidePanelHeader>
        <AddContentSection builderType={BuilderType.Webpage} />
      </>
    )}
  </SidePanelForm>
)

export default EditPageContentModalSettingsPanel
